export const IDS = {
  navBrand: "nav-brand",
  navBookBtn: "nav-book-btn",
  navMobileToggle: "nav-mobile-toggle",
  navMobileMenu: "nav-mobile-menu",
  heroBookBtn: "hero-book-btn",
  heroCallBtn: "hero-call-btn",
  heroTitle: "hero-title",
  featuredSection: "featured-services",
  viewFullPriceListBtn: "view-full-price-list-btn",
  servicesSearch: "services-search",
  servicesAccordion: "services-accordion",
  faqAccordion: "faq-accordion",
  contactForm: "contact-form",
  contactSubmit: "contact-submit-btn",
  bookForm: "book-form",
  bookSubmit: "book-submit-btn",
  bookName: "book-name",
  bookPhone: "book-phone",
  bookEmail: "book-email",
  bookService: "book-service",
  bookDate: "book-date",
  bookTime: "book-time",
  bookNotes: "book-notes",
  footer: "site-footer",
};
